import { createAction, props } from '@ngrx/store';

export const loadDownloadPayrollDocuments = createAction(
  '[DownloadPayrollDocument] Load DownloadPayrollDocuments',
  props<{ businessId: string; paymentDueDate: string }>()
);

export const loadDownloadPayrollDocumentsSuccess = createAction(
  '[DownloadPayrollDocument] Load DownloadPayrollDocuments Success',
  props<{ response: any }>()
);

export const loadDownloadPayrollDocumentsFailure = createAction(
  '[DownloadPayrollDocument] Load DownloadPayrollDocuments Failure',
  props<{ error: Error | any }>()
);
